@if ((vm$ | async); as vm) {
  <div>
    <button id="reOpenDoorBtn" class="btn btn--obsidian-31 width100" [ngClass]="{'hide': vm.isSimulatedMode, 'is-disabled': vm.isButtonDisabled}"
      [disabled]="vm.isButtonDisabled" (click)="buttonClicked(vm.isButtonDisabled)">
      <svg id="reOpenDoorBtnSpinner" class="spinner width-2 height-2" viewBox="0 0 66 66" [ngClass]="{'hide': !vm.isSpinnerShowing}">
        <circle class="spinner-path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
      </svg>
      @if (vm.isAccessPointUnlocked) {
        <svg id="unlockDoorIcon" class="fill-navy-80">
          <use xlink:href="./assets/icons/connect-icons.svg#Unlock"></use>
        </svg>
      }
      @if (vm.isAccessPointOpen) {
        <svg id="openDoorIcon" class="fill-navy-80">
          <use xlink:href="./assets/icons/connect-icons.svg#Open-Door"></use>
        </svg>
      }
      @if ((!vm.isSpinnerShowing && !vm.idDoesNotMatch && !vm.isSimulatedMode && !vm.isVirtual)) {
        <span id="reOpenDoorName" class="ml1">Reopen
          Door</span>
      }
      @if (vm.isVirtual) {
        <span id="virtualReopenDoor" class="ml1">Virtual Door</span>
      }
      @if (vm.isSpinnerShowing) {
        <span id="unlockingName" class="ml1">Unlocking Door</span>
      }
      @if (vm.idDoesNotMatch) {
        <span id="queueName" class="ml1">Queue Door</span>
      }
    </button>
    <button class="btn btn--transparent width100 bg-gray-97 border-0 flex align-center" disabled="" [ngClass]="{'hide': !vm.isSimulatedMode}">
      <svg class="h4 fill-teal-36">
        <use xlink:href="./assets/icons/connect-icons.svg#Lock-Bypassed"></use>
      </svg>
      <div class="ml1 teal-36 js-door-status-text">Lock Bypassed</div>
    </button>
  </div>
}